/**
 * Trilingual (TR / EN / DE) strings for the contact / RFQ form.
 *
 * Every string here is lifted VERBATIM from the existing per-locale form markup
 * (App.jsx for TR, pages/en/AppEN.jsx for EN, pages/de/AppDE.jsx for DE) so the
 * shared ContactForm renders identical copy to today. Keep strict TR/EN/DE
 * parity: any change to one locale must be mirrored in the other two.
 *
 * Shape per locale:
 *   labels        — visible field labels (name/email/company/phone/message)
 *   placeholders  — input placeholders (name/email/company/phone/message)
 *   messages      — status + control copy (success, errors, captcha, submit)
 *
 * @typedef {Object} FormLocaleStrings
 * @property {{ name: string, email: string, company: string, phone: string, message: string }} labels
 * @property {{ name: string, email: string, company: string, phone: string, message: string }} placeholders
 * @property {{
 *   successTitle: string,
 *   successBody: string,
 *   successAgain: string,
 *   errorGeneric: string,
 *   captchaRequired: string,
 *   captchaLabel: string,
 *   submit: string,
 *   submitSending: string
 * }} messages
 */

/** @type {{ tr: FormLocaleStrings, en: FormLocaleStrings, de: FormLocaleStrings }} */
export const FORM_I18N = {
  tr: {
    labels: {
      name: 'Ad Soyad *',
      email: 'E-posta *',
      company: 'Firma Adı',
      phone: 'Telefon',
      message: 'Mesajınız *',
    },
    placeholders: {
      name: 'Adınız Soyadınız',
      email: 'ornek@firma.com',
      company: 'Firma Adınız',
      phone: '+90 XXX XXX XX XX',
      message: 'Projeniz hakkında bilgi verin...',
    },
    messages: {
      successTitle: 'Mesaj Gönderildi',
      successBody: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
      successAgain: 'Yeni Mesaj Gönder',
      errorGeneric: 'Gönderim sırasında bir hata oluştu. Lütfen tekrar deneyin.',
      captchaRequired: 'Lütfen güvenlik doğrulamasını tamamlayın',
      captchaLabel: 'Güvenlik doğrulaması',
      submit: 'Mesaj Gönder',
      submitSending: 'Gönderiliyor...',
    },
  },
  en: {
    labels: {
      name: 'Full Name *',
      email: 'Email *',
      company: 'Company Name',
      phone: 'Phone',
      message: 'Your Message *',
    },
    placeholders: {
      name: 'Your Full Name',
      email: 'example@company.com',
      company: 'Your Company',
      phone: '+1 XXX XXX XXXX',
      message: 'Tell us about your project...',
    },
    messages: {
      successTitle: 'Message Sent',
      successBody: "Your message has been sent successfully. We'll get back to you shortly.",
      successAgain: 'Send Another Message',
      errorGeneric: 'An error occurred. Please try again.',
      captchaRequired: 'Please complete the security check',
      captchaLabel: 'Security check',
      submit: 'Send Message',
      submitSending: 'Sending...',
    },
  },
  de: {
    labels: {
      name: 'Vor- und Nachname *',
      email: 'E-Mail *',
      company: 'Firmenname',
      phone: 'Telefon',
      message: 'Ihre Nachricht *',
    },
    placeholders: {
      name: 'Ihr Vor- und Nachname',
      email: 'beispiel@firma.com',
      company: 'Ihre Firma',
      phone: '+49 XXX XXX XXXX',
      message: 'Erzählen Sie uns von Ihrem Projekt...',
    },
    messages: {
      successTitle: 'Nachricht gesendet',
      successBody:
        'Ihre Nachricht wurde erfolgreich versendet. Wir werden uns in Kürze bei Ihnen melden.',
      successAgain: 'Weitere Nachricht senden',
      errorGeneric: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      captchaRequired: 'Bitte schließen Sie die Sicherheitsprüfung ab',
      captchaLabel: 'Sicherheitsprüfung',
      submit: 'Nachricht senden',
      submitSending: 'Wird gesendet...',
    },
  },
}
